import api from './api';

const state = {
	adapterRuns: [],
	loading: false,
	error: false,
	message: '',
	success: false,
	limit: 10,
	page: 0,
	foundAll: false,
};

const getters = {};

const mutations = {
	startLoading(state) {
		state.loading = true;
	},
	stopLoading(state) {
		state.loading = false;
	},
	setAdapterRuns(state, { adapterRuns }) {
		state.adapterRuns = adapterRuns;
	},
	appendAdapterRuns(state, { adapterRuns }) {
		state.adapterRuns = state.adapterRuns.concat(adapterRuns);
	},
	reset(state) {
		state.page = 0;
		state.adapterRuns = [];
		state.foundAll = false;
	},
	updateDeletedState(state, { adapterRun, showDeleted }) {
		const idx = state.adapterRuns.findIndex((run) => run.id == adapterRun.id);
		state.adapterRuns[idx].deleted = !state.adapterRuns[idx].deleted;
		if (state.adapterRuns[idx].deleted && showDeleted == false) {
			state.adapterRuns.splice(idx, 1);
		}
	},
	showError(state, { message }) {
		state.error = true;
		state.message = message;
	},
	hideError(state) {
		state.error = false;
	},
	showSuccess(state) {
		state.success = true;
	},
	hideSuccess(state) {
		state.success = false;
	},
	updateOffset(state) {
		state.page += 1;
	},
	reducePage(state) {
		state.page -= 1;
	},
	foundAll(state) {
		state.foundAll += true;
	},
	updateAdapterRun(state, { adapterRun }) {
		let adapterRunsClone = [...state.adapterRuns];
		const idx = adapterRunsClone.findIndex((run) => run.id == adapterRun.id);
		adapterRun.created = new Date(adapterRun.createdAt).toISOString().substring(0, 10);
		adapterRun.started = new Date(adapterRun.startedAt).toISOString().substring(11, 19);
		adapterRun.duration = new Date(adapterRun.endedAt) - new Date(adapterRun.startedAt);
		adapterRunsClone[idx] = adapterRun;
		state.adapterRuns = adapterRunsClone;
	},
};

const actions = {
	load({ state, commit, rootGetters }, { showDeleted, limit, offset }) {
		commit('updateOffset');
		commit('startLoading');
		return api
			.load(showDeleted, limit, offset)
			.then((response) => {
				const adapterRuns = response.data;
				if (offset == 0) {
					commit('setAdapterRuns', { adapterRuns });
				} else {
					commit('appendAdapterRuns', { adapterRuns });
				}
				commit('stopLoading');
				return adapterRuns;
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError', { message });
				commit('stopLoading');
			});
	},

	async deleteAdapterLog({ state, commit, rootGetters, dispatch }, { adapterRun, showDeleted }) {
		var result;
		if (!adapterRun.deleted) {
			result = api.deleteAdapterLog(adapterRun);
		} else {
			const copy = { ...adapterRun };
			copy.deleted = false;
			result = api.editAdapterLog(copy);
		}
		return result
			.then(() => {
				const page = state.page;
				commit('showSuccess');
				commit('updateDeletedState', { adapterRun, showDeleted });
				window.setTimeout(() => {
					commit('hideSuccess');
				}, 1500);
			})
			.catch((err) => {
				console.log(err);
				const message = err.response.data.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},

	socket_frameworkReloadAdapterRuns({ dispatch, state, commit }) {
		const limit = state.limit * state.page;
		commit('reducePage');
		dispatch('load', { showDeleted: false, limit: limit, offset: 0 });
	},

	socket_frameworkUpdateAdapterRun({ dispatch, state, commit }, { id }) {
		return api
			.findAdapterRun(id)
			.then((response) => {
				const adapterRun = response.data;
				commit('updateAdapterRun', { adapterRun });
			})
			.catch((err) => {
				const message = err.response.data.message;
				commit('showError', { message });
				window.setTimeout(() => {
					commit('hideError');
				}, 3000);
				return message;
			});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
